import styled from "styled-components";

export const PaymentModalWrapper = styled.div(() => {
  return {
    ".pm-paystack-wrapper": {
      flex: 1,
      display: "flex",
    },
    ".pm-paystack-button": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#ffffff !important",
      backgroundColor: "#2e7d32 !important",
      border: "1px solid #2e7d32 !important",
      borderRadius: "8px",
      padding: "0 20px",
      height: "44px",
      width: "100%",
      cursor: "pointer",
      display: "flex !important",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      transition: "background-color 0.15s ease, transform 0.15s ease",
      "&:hover": {
        backgroundColor: "#256427 !important",
      },
      "&:active": {
        transform: "scale(0.98)",
      },
    },
  };
});

export const ModalHeader = styled.div(() => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "12px",
    ".pm-header-text": {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    ".pm-title": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "28px",
      color: "#333333",
      margin: 0,
    },
    ".pm-subtitle": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "20px",
      color: "#666666",
      margin: 0,
    },
  };
});

export const CloseButton = styled.button(() => {
  return {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#f3f4f6",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    padding: 0,
    color: "#374151",
    fontSize: "16px",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: "#e5e7eb",
      transform: "scale(1.05)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
  };
});

export const FormGrid = styled.div(() => {
  return {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  };
});

export const FormGroup = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  };
});

export const FormLabel = styled.label(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#00838f",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  };
});

export const FormSelect = styled.select(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#333333",
    padding: "10px 14px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    appearance: "none",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666666' d='M2.5 4.5L6 8l3.5-3.5'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    paddingRight: "32px",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#1976d2",
      boxShadow: "0 0 0 3px rgba(25,118,210,0.12)",
    },
    "& option[value=''][disabled]": {
      color: "#999999",
    },
  };
});

export const FormInput = styled.input(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#333333",
    padding: "10px 14px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#1976d2",
      boxShadow: "0 0 0 3px rgba(25,118,210,0.12)",
    },
    "&::placeholder": {
      color: "#999999",
    },
  };
});

export const AmountInputWrapper = styled.div(() => {
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
  };
});

export const PaymentCard = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "2px solid #2e7d32",
    borderRadius: "10px",
    padding: "14px 16px",
    backgroundColor: "rgba(46,125,50,0.14)",
    cursor: "default",
    transition: "border-color 0.15s ease, background-color 0.15s ease",
  };
});

export const PaymentCardLeft = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  };
});

export const RadioIndicator = styled.div(() => {
  return {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: "2px solid #2e7d32",
    backgroundColor: "#2e7d32",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    position: "relative",
    "&::after": {
      content: "''",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#ffffff",
    },
  };
});

export const PaymentMethodLabel = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    ".pm-method-name": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#333333",
    },
    ".pm-method-desc": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      color: "#666666",
    },
  };
});

export const PaymentCardRight = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  };
});

export const SecureBadge = styled.div(() => {
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "rgba(0,131,143,0.10)",
    borderRadius: "12px",
    padding: "3px 10px",
    ".pm-secure-icon": {
      fontSize: "12px",
      color: "#00838f",
    },
    ".pm-secure-text": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#00838f",
      letterSpacing: "0.01em",
    },
  };
});

export const PaystackWordmark = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    svg: {
      height: "20px",
      width: "auto",
    },
  };
});

export const ModalFooter = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    paddingTop: "4px",
  };
});

export const CancelButton = styled.button(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#ffffff",
    backgroundColor: "#8b1a1a",
    border: "1px solid #8b1a1a",
    borderRadius: "8px",
    padding: "0 20px",
    height: "44px",
    cursor: "pointer",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: "#7a1515",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  };
});

export const ContinueButton = styled.button(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#ffffff",
    backgroundColor: "#2e7d32",
    border: "1px solid #2e7d32",
    borderRadius: "8px",
    padding: "0 20px",
    height: "44px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minWidth: "120px",
    transition:
      "background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      backgroundColor: "#256427",
      boxShadow: "0 2px 8px rgba(46,125,50,0.25)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    ".pm-spinner": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };
});

export const ErrorText = styled.p(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    color: "#dc2626",
    margin: 0,
    padding: "0",
  };
});

export const SuccessBadge = styled.div(() => {
  return {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "rgba(46,125,50,0.13)",
    border: "2px solid rgba(46,125,50,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    svg: {
      width: "30px",
      height: "30px",
    },
  };
});

export const Step2Header = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0",
    ".pm-step2-title": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "24px",
      color: "#333333",
      margin: 0,
    },
  };
});

export const DetailRow = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: "1px solid #f0f0f0",
    ".pm-detail-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "18px",
      color: "#666666",
    },
    ".pm-detail-value": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "13px",
      lineHeight: "18px",
      color: "#333333",
      textAlign: "right",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  };
});

export const TotalRow = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
    backgroundColor: "rgba(46,125,50,0.13)",
    borderRadius: "8px",
    marginTop: "8px",
    ".pm-total-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#333333",
    },
    ".pm-total-value": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "15px",
      lineHeight: "20px",
      color: "#2e7d32",
    },
  };
});

export const StatusPill = styled.span(() => {
  return {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "100px",
    padding: "3px 10px",
    backgroundColor: "rgba(0,131,143,0.10)",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#00838f",
    letterSpacing: "0.01em",
  };
});
